import { Suspense } from 'react'
import { Outlet } from 'react-router-dom'

import { OfflineBanner } from '@/components/feedback/OfflineBanner'
import { PageLoader } from '@/components/feedback/PageLoader'
import { PageHeader } from '@/components/layout/PageHeader'
import { WorkspaceNav } from '@/components/layout/WorkspaceNav'
import { usePageMeta } from '@/app/router/routeMeta'
import { cn } from '@/lib/utils/cn'
// The nav bar's "Kunde erstellen" button is global, so the modal it opens has to
// live in the shell rather than a page — the one deliberate exception to
// components/ not reaching into features/, same spirit as the auth bridge.
import { LeadIntakeModal } from '@/features/pipeline/components/LeadIntakeModal'
import { useLeadIntakeOpen, useUiStore } from '@/stores/uiStore'

import styles from './AppShell.module.css'

export function AppShell() {
  const meta = usePageMeta()
  const layout = meta?.layout ?? 'default'
  const leadIntakeOpen = useLeadIntakeOpen()
  const closeLeadIntake = useUiStore((state) => state.closeLeadIntake)

  return (
    <div className={styles.shell}>
      <OfflineBanner />
      <WorkspaceNav />
      <PageHeader />

      <div className={styles.scroll}>
        <main className={cn(styles.main, layout !== 'default' && styles[layout])}>
          <Suspense fallback={<PageLoader />}>
            <Outlet />
          </Suspense>
        </main>
      </div>

      <LeadIntakeModal open={leadIntakeOpen} onClose={closeLeadIntake} />
    </div>
  )
}
